<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <div :class="[deviceType, 'title']">
      <h1>{{ t("ccOnBoarding.resume.draftListTitle") }}</h1>
      <p>{{ t("ccOnBoarding.resume.draftListDesc") }}</p>
    </div>
    <div :class="[deviceType, 'draftContainer']">
      <div
        :class="[deviceType, 'singleDraft']"
        v-for="draft in prop.resumeDraftData"
      >
        <div :class="[deviceType, 'cardContainer']">
          <!-- <p class="cardName" style="text-align: center"> -->
          <p v-if="draft.cardType" class="cardName">
            {{ draft.cardType }}
          </p>
          <p v-else class="noCard">
            {{ t("ccOnBoarding.resume.noCard") }}
          </p>
          <span v-if="overlay" class="imgOverlay">
            <div class="spinner-border" role="status">
              <span class="sr-only">{{
                t("ccOnBoarding.uploadDocument.loading2")
              }}</span>
            </div>
          </span>
          <span v-else>
            <!-- <span style="display: flex; justify-content: center" v-else> -->
            <img
              style="
                width: 100%;
                max-width: 215px;
                margin-bottom: 15px;
                max-height: 150px;
              "
              class="path-65"
              v-if="draft.cardImg"
              :src="'data:image/png;base64,' + draft.cardImg"
            />
            <img
              style="
                width: 100%;
                max-width: 215px;
                margin-bottom: 15px;
                max-height: 150px;
              "
              class="path-65"
              v-else
              :src="test"
            />
          </span>
        </div>
        <div style="width: 100%; max-width: 330px">
          <p class="progressDesc">
            {{ draft.progress }}{{ t("ccOnBoarding.resume.progress") }}
          </p>
          <div class="progress-bar">
            <div
              class="progress-bar-inside"
              :style="{ width: progressBarWidth(draft.progress) }"
            ></div>
          </div>

          <div class="contentList">
            <p>{{ t("ccOnBoarding.resume.dateCreated") }}</p>
            <p>{{ draft.createdDate }}</p>
          </div>
          <div class="contentList">
            <p>{{ t("ccOnBoarding.resume.applicationMethod") }}</p>
            <p>{{ draft.type }}</p>
          </div>
          <div class="contentList">
            <p>{{ t("ccOnBoarding.resume.merchantCode") }}</p>
            <p>{{ draft.merchantCode || "-" }}</p>
          </div>
          <div class="contentList">
            <p>{{ t("ccOnBoarding.resume.referenceNumber") }}</p>
            <p>{{ draft.reference }}</p>
          </div>
          <div class="contentList">
            <p>{{ t("ccOnBoarding.resume.branchCode") }}</p>
            <p>{{ draft.branchCode }}</p>
          </div>
          <div class="contentList">
            <p>{{ t("ccOnBoarding.resume.agentID") }}</p>
            <template v-if="draft.recruiterName">
              <p>{{ draft.recruiterName }}</p>
            </template>
            <template v-else>
              <p>-</p>
            </template>
          </div>
          <button
            :class="[deviceType, 'right-button']"
            @click="selectResume(draft.webFormRequestId)"
          >
            {{ t("ccOnBoarding.resume.buttonContinue") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import i18n from "@/plugin/i18n";
import { inject } from "vue";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import Headers from "./../components/Headers.vue";
import { useRouter } from "vue-router";
import test from "@/assets/cc_img/no_card_image.png";

const deviceType = inject("deviceType");
const { t } = i18n.global;
const overlay = ref(true);
const router = useRouter();

const prop = defineProps({
  resumeDraftData: {
    type: Object,
    required: true,
  },
});

onMounted(() => {
  const requestModel = {
    nationality: "",
  };

  MasterService.cardValidate(requestModel)
    .then((res) => {
      for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
        for (let j = 0; j < prop.resumeDraftData.length; j++) {
          if (
            res.data.responseModel.cardList[i].cardCode ==
            prop.resumeDraftData[j].cardId
          ) {
            // console.log(res.data.responseModel.cardList[i]);
            prop.resumeDraftData[j].cardImg =
              res.data.responseModel.cardList[i].cardImage;
          }
        }
      }
      overlay.value = false;
    })
    .catch((e) => {});
});

const selectResume = (webFormRequestId: string) => {
  router.push({
    name: "CCProgressRoutePage",
    state: {
      draftListing: true,
    },
    query: {
      webFormRequestId: webFormRequestId,
    },
  });
};

const progressBarWidth = (progress: any) => {
  const totalSteps = 100;
  const numericValue = parseFloat(progress);
  const widthPercentage = (numericValue * 100) / totalSteps;
  return `${widthPercentage}%`;
};
</script>

<style scoped>
.title:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.draftContainer:is(.Mobile) {
  padding: 0 20px;
}

h1 {
  color: var(--Web-Black-High, #212121);

  /* Custom 3 */
  font-family: Outfit;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 31.2px */
}

.title p {
  color: var(--Web-Black-Medium, #757575);

  /* Body (Regular) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}

.singleDraft {
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16);
  margin: 32px auto;
  max-width: 650px;
}

.cardContainer {
  max-width: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contentList {
  display: flex;
  justify-content: space-between;
  word-wrap: break-word;
}

.contentList p:first-child {
  color: var(--Web-Black-Medium, #757575);

  /* Caption 3 Medium */
  font-family: Outfit;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 14.3px */
  margin: 3px;
}

.contentList p:nth-child(2) {
  color: var(--Web-Black-High, #212121);

  /* Caption 3 Medium */
  font-family: Outfit;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 14.3px */
  margin: 3px;
  width: 50%;
  text-align: end;
}

.cardName {
  text-align: left;
  color: var(--Primary-Active, #ac2887);
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 20.8px */
}

.noCard {
  text-align: left;
  color: #9e9e9e;
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 20.8px */
}

.right-button {
  margin-top: 12px;
  width: 100%;
  height: 32px;
  padding: 8px 16px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.progressDesc {
  color: var(--Web-Black-High, #212121);

  /* Caption 3 Medium */
  font-family: Outfit;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 14.3px */
  margin-bottom: 3px;
}

.singleDraft:is(.Mobile) {
  flex-flow: column;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
}

.imgOverlay {
  display: flex;
  justify-content: center;
}
</style>
